import 'reactjs-popup/dist/index.css';
import {TooltipContainer, Status, Actions, ActionButton, AbsoluteContainer,DivRelative } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { removeAutoDetected, resetSpecialEdgesAndGutterLines, setAutoEdgeDetectedConfirmed } from 'store/slices/RoofToolLinesSlice';
import { useRefs } from 'contexts/RefContext';
import { RIGHT_PANEL_MOBILE_BREAKPOINT } from '../../../../../../../constants';
import useScreenDims from 'hooks/useScreenDims';
import { selectUpdatedEdges, selectUpdatedGutterLines } from 'store/slices/RoofDataSlice/roofSelector';

export default function AutoDetectConfirmationPopup() {
	const { enabled: openConfirmationPopup, confirmed } = useSelector((s: RootState) => s.roofToolLines.autoEdgeDetection);
	const { showAutoDetectedEdges } = useSelector((s: RootState) => s.roofData.data);
	const { fullScreenEnabled } = useSelector((s: RootState) => s.toolNewPostions.data);

	const dispatch = useDispatch();

	const autoDetectedEdgesConfirmedOnce = showAutoDetectedEdges || confirmed;

	const updatedSpecialEdges = useSelector(selectUpdatedEdges);
	const updatedGutteLines = useSelector(selectUpdatedGutterLines);
	
	const { width: screenWidth } = useScreenDims();
	const showMobileView = screenWidth <= RIGHT_PANEL_MOBILE_BREAKPOINT;

	function handleDiscard() {
		if (!autoDetectedEdgesConfirmedOnce) {
			dispatch(removeAutoDetected());
		}else{
			dispatch(resetSpecialEdgesAndGutterLines({specialEdges: updatedSpecialEdges, gutterLines:  updatedGutteLines}));
		}
		dispatch(setAutoEdgeDetectedConfirmed(false));
	}

	function handleConfirmation() {
		dispatch(setAutoEdgeDetectedConfirmed(true));
	}

	const { desktopViewWrapRef } = useRefs();

	if(!openConfirmationPopup) return null;
	return (
	// <Popup
	// 	open={openConfirmationPopup}
	// 	arrow={false}
	// 	closeOnDocumentClick={false}
	// 	contentStyle={popupContentStyle}
	// 	overlayStyle={{
	// 		background: 'transparent',
	// 	}}
	// >
		<AbsoluteContainer>
			<DivRelative>
				<TooltipContainer className='auto-detect-popup' style={{
					position: 'absolute',
					zIndex: '999999',
					right: 'inherit',
					transform: showMobileView ? 'translateX(-50%)' : (fullScreenEnabled ? 'translateX(-50%)': `translateX(calc(-50% - ${(desktopViewWrapRef?.current?.clientWidth ?? 360)/2}px))`)
				}}>
					<Status>
							Confirm the auto-detected edges?
					</Status>

					<Actions>
						<ActionButton className='discard-btn' onClick={handleDiscard}>Discard</ActionButton>
						<ActionButton className='confirm-btn' onClick={handleConfirmation}>Confirm</ActionButton>
					</Actions>

					{/* <CloseButton id="cancel-auto-detction-popup">
						<svg
							width="15"
							height="15"
							viewBox="0 0 16 16"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								id="cancel-path"
								d="M0.947266 0.947266L14.2631 14.2631M14.2631 0.947266L0.947265 14.2631"
								stroke='#989898'
								strokeWidth="1.6"
								strokeLinecap="round"
							/>
						</svg>
					</CloseButton> */}
				</TooltipContainer>
			</DivRelative>
		</AbsoluteContainer>

	// </Popup>
	);
}